// extracted by mini-css-extract-plugin
export default {"searchInputFormGroup":"mfr-py98fen7","optionsContainer":"mfr-Y_JTkI87","applySelectionContainer":"mfr-O5k2oklR"};